import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
gsap.registerPlugin(ScrollToPlugin);

var api =
  'https://listenventures.staging.wpengine.com/wp-json/wp/v2/posts?_embed';

// Check where we're at and vars //
var blogCategories = document.querySelector('[data-bloglist]');
var loadButton = document.querySelector('[data-loadposts]');
if (loadButton) {
  var loadButtonValue = loadButton.dataset.loadposts;
  var loadButtonTotal = loadButton.dataset.totalposts;
}

// Call the API
function fetchCall() {
  fetch(api)
    .then(function (response) {
      // The API call was successful!
      if (response.ok) {
        return response.json();
      } else {
        return Promise.reject(response);
      }
    })
    .then(function (data) {
      // This is the JSON from our response
      console.log(data);
      data.sort(function (a, b) {
        a.date > b.date ? 1 : -1;
      });
      // Strip unwanted results
      var results = data.slice(6);
      // Store data in session storage for usage later
      sessionStorage.setItem('results', JSON.stringify(data));
    })
    .then(function () {
      const posts = JSON.parse(sessionStorage.getItem('results')) || {};
      resultsBuild(posts);
    })

    .catch(function (err) {
      // There was an error
      console.warn('Something went wrong.', err);
    });
}

function resultsBuild(posts, count) {
  console.log(posts.length);
  blogCategories.innerHTML += posts
    .map(function (post) {
      // Fetch excerpt a limit characters //
      var excerpt = post.acf.content_blocks[0].text;
      excerpt = excerpt.substring(0, 150);
      // Featured Image
      var image = post.featured_image_url;
      if (image) {
        var imageOutput =
          '<img src="' + image + '" alt="' + post.title + '" />';
      } else {
        var imageOutput =
          '<svg width="768" height="500"><rect width="768" height="500" style="fill:#EDEDED"></rect></svg>';
      }
      // Categories //
      var categories = [];
      var catList = post.categories;
      catList.forEach(function (item) {
        categories.push(item);
      });
      var html =
        '<div class="blog__categories-item w-full lg:w-1/3 px-20" data-categories="' +
        categories +
        '">' +
        '<div class="image">' +
        imageOutput +
        '</div>' +
        '<h3 class="sans">' +
        '<a href="' +
        post.link +
        '">' +
        post.title.rendered +
        '</a>' +
        '</h3>' +
        '<div class="text">' +
        excerpt +
        '...' +
        '</div>' +
        '</div>';
      return html;
    })
    .join('');
  if (posts.length < 6) {
    loadButton.classList.add('hide');
  } else {
    console.log('👍 More posts to load');
  }
}

export const initialBuild = () => {
  if (blogCategories) {
    if (sessionStorage.getItem('results') === null) {
      fetchCall();
    } else {
      const posts = JSON.parse(sessionStorage.getItem('results')) || {};
      resultsBuild(posts);
    }
  }
};

export const backToTop = () => {
  // Back to Top //

  document.addEventListener('click', (e) => {
    if (!e.target.closest('[data-backup')) return;
    gsap.to(window, { duration: 2, scrollTo: 0 });
  });
};

export const mailList = () => {
  const target = document.querySelector('.maillist');

  if (!target) return;

  // Mailist open animation //
  const tl = gsap.timeline({ paused: true });
  tl.to('.maillist__button', { opacity: 0 });
  tl.to('.maillist', { width: '335px', height: '370px', borderRadius: 0 });
  tl.set('.mailist__form', { opacity: 0 });
  tl.set('.mailist__form', { maxHeight: '9999px' });
  tl.to('.mailist__form', { opacity: 1 });
  tl.to('.mailist__form-close', { opacity: 1 });

  document.addEventListener('click', (e) => {
    if (e.target.closest('.maillist__button')) {
      tl.play();
    }
    if (e.target.closest('[data-action="close-mailist"]')) {
      tl.reverse(0);
    }
  });
};

export const catList = () => {
  let buttonState = true;
  const target = document.querySelector('.cat-list');
  document.addEventListener('click', (e) => {
    if (!e.target.closest('[data-catmenu]')) return;
    if (buttonState) {
      target.classList.add('cat-list__open');
      e.target.classList.add('category-button__arrow--open');
      buttonState = false;
    } else {
      target.classList.remove('cat-list__open');
      e.target.classList.remove('category-button__arrow--open');
      buttonState = true;
    }
  });
};
